import { ConvertHelper, StringHelper } from '@barthauer/abc/core';
import { ParameterValue } from './models/parameter-value.model';

export class ParameterHelper {
  public static getDateValue(dateValue: any, nullable: boolean = false): object | null {
    if (!nullable) {
      if (!dateValue) {
        dateValue = new Date();
      }
    }

    if (dateValue) {
      return { Date: ConvertHelper.toISODateString(dateValue) };
    } else {
      return null;
    }
  }

  public static getTimeValue(timeValue: any, nullable: boolean = false): object | null {
    if (!nullable) {
      if (!timeValue) {
        timeValue = new Date();
      }
    }

    if (timeValue) {
      return { Time: ConvertHelper.toISOTimeString(timeValue) };
    } else {
      return null;
    }
  }

  public static getDateTimeValue(dateTimeValue: any, nullable: boolean = false): object | null {
    if (!nullable) {
      if (!dateTimeValue) {
        dateTimeValue = new Date();
      }
    }

    if (dateTimeValue) {
      return {
        DateTime: ConvertHelper.toISODateString(dateTimeValue) + 'T' + ConvertHelper.toISOTimeString(dateTimeValue),
      };
    } else {
      return null;
    }
  }

  public static getBase64StringAsFileValue(base64Value: string, nullable: boolean = false): object | null {
    if (!nullable) {
      if (!base64Value) {
        base64Value = '';
      }
    }

    if (base64Value || !nullable) {
      return {
        Base64StringAsFile: base64Value,
      };
    } else {
      return null;
    }
  }

  public static getBase64BytesAsFileValue(base64Value: string, nullable: boolean = false): object | null {
    if (!nullable) {
      if (!base64Value) {
        base64Value = '';
      }
    }

    if (base64Value || !nullable) {
      return {
        Base64BytesAsFile: base64Value,
      };
    } else {
      return null;
    }
  }

  public static ensureParameterValues(parameters: ParameterValue[], parametersToAdd: ParameterValue[]): void {
    if (parametersToAdd?.length) {
      for (const parameter of parametersToAdd) {
        const name = this.getNormalizedName(parameter.Name);
        let p = parameters.find((_) => this.getNormalizedName(_.Name) == name);
        if (!p) {
          p = new ParameterValue(parameter.Name);
          parameters.push(p);
        }
        p.Value = parameter.Value;
      }
    }
  }

  public static combineParameterValues(parameters1: ParameterValue[], parameters2: ParameterValue[]): ParameterValue[] {
    if (parameters1?.length || parameters2?.length) {
      const result: ParameterValue[] = [];
      this.ensureParameterValues(result, parameters1);
      this.ensureParameterValues(result, parameters2);
      return result;
    }
    return [];
  }

  public static getNormalizedName(name: string): string {
    return name?.toLowerCase();
  }

  public static isValidParameterName(name: string): boolean {
    if (name?.length) {
      for (let i = 0; i < name.length; i++) {
        if (i == 0) {
          if (!StringHelper.isLetter(name, i)) {
            return false;
          }
        } else if (!StringHelper.isLetterOrDigit(name, i) && name.charCodeAt(i) !== '_'.charCodeAt(0)) {
          return false;
        }
      }
      return true;
    }
    return false;

  }
}
